import "whatwg-fetch";
import "babel-polyfill";

import objectFitImages from 'object-fit-images' ; // object-fit polyfill

import Accordion from './Accordion';
import CookieBar from './CookieBar';
import StickyNav from './StickyNav';
import StickyPillars from './StickyPillars';
import StickyFooterLink from './StickyFooterLink';
import GetStarted from './GetStarted';
import Flyouts from './Flyouts';
import LazyPagination from './LazyPagination';
import Filter from './Filter';
import SliderGeneral from './SliderGeneral';
import SwiperMobile from './SwiperMobile';
import SliderMobile from './SliderMobile';
import SliderFeature from './SliderFeature';
import MobilePriceTable from './MobilePriceTable';
import Comboplete from './Comboplete';
import SingleFeature from './SingleFeature';
import Header from './Header';
import GoogleMap from './GoogleMap';
import IframeVideo from './IframeVideo';

const $ = jQuery;

$('.loader').remove();

$(document).ready(() => {
    let $body = $('body');
    let $window = $(window);

    // Load GoogleMaps
    if ($('[data-gmap]').length > 0) {
        GoogleMap.loadApi();
    }

    // Handle page transition classes
    $window.on('load', event => {
        $body.removeClass('is-loading loading').addClass('has-loaded');

        // Load Swiper
        new SliderGeneral('.swiper__container--general');

        // Load MobileSlider
        new SliderMobile('.swiper__container--mobile');

        // Load MobileSwiper
        new SwiperMobile('.swiper__container--mobileswiper');

        // Load FeatureSlider
        new SliderFeature('.swiper__container--ptfeature');

        // Load MobilePriceTable
        new MobilePriceTable;

        // Load Header
        new StickyNav;

        // Load Pilalrs
        new StickyPillars;

        // Copy menu__item--get-started to sticky footer
        new StickyFooterLink;

        // Get Started links
        new GetStarted();
        new GetStarted('.menu__item--get-started a');

        // Load Header
        new Flyouts;

        // Load lazy pagination
        new LazyPagination;

        // Load Filter
        new Filter;

        // Load object-fit polyfill
        objectFitImages($('img'));

        // Load Accordion
        new Accordion;

        // Load CookieBar
        new CookieBar;

        new Comboplete;

        new SingleFeature;

        new Header;

        Array.from(document.querySelectorAll('.media--iframe__video')).forEach(iframeEl => {
            new IframeVideo(iframeEl);
        });
    });
});



// WEBPACK FOOTER //
// ./app/themes/template/res/js/src/main.js